import request from "@/utils/request"
const platform = localStorage.getItem('platform')

export function getRoiStats(data) {
    return request.get(`/${platform}/stats/roi`, data)
}

export function getOrderStats(data) {
    return request.get(`/${platform}/stats/order`, data)
}

export function getRealStats(data) {
    return request.get(`/${platform}/stats/real`, data)
}

export function getRealStatsV2(data) {
    return request.get(`/${platform}/stats/real_v2`, data)
}

export function getHourStats(data) {
    return request.get(`/${platform}/stats/hourly`, data)
}

export function getRankStats(data) {
    return request.get(`/${platform}/stats/cost_rank`, data)
}

export function getRankStatsV2(data) {
    return request.get(`/${platform}/stats/cost_rank_v2`, data)
}

export function getRecharges(data) {
    return request.get(`/${platform}/stats/recharges`, data)
}

export function getRechargeStat(data) {
    return request.get(`/${platform}/stats/recharge_stat`, data)
}

export function getTeamStats(data) {
    return request.get(`/${platform}/stats/team_stat`, data)
}

export function getRealMonthlyStats(data) {
    return request.get(`/${platform}/stats/real_monthly`, data)
}

// 导出真实月度报表，后端会按当前筛选条件生成 CSV 并返回下载地址。
export function exportRealMonthlyStats(data) {
    return request.get(`/${platform}/stats/real_monthly/export`, data)
}

export function getVideoStats(data) {
    return request.get(`/${platform}/stats/video_stats`, data)
}

export function getTotalIncome(data) {
    return request.get(`/${platform}/stats/total_income`, data)
}

export function getMonthRankIncome(data) {
    return request.get(`/${platform}/stats/month_rank_income`, data)
}

export function getDayRankIncome(data) {
    return request.get(`/${platform}/stats/day_rank_income`, data)
}

export function getMonthIncomeReport(data) {
    return request.get(`/${platform}/stats/month_income_report`, data)
}
